import React, { useEffect, useState } from "react";
import { useQuerySearch } from "../../../utils/hooks/partSearch";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/store";
import Categories from "../Categories";
import Search from "../Search";
import PartDrawer from "../PartDrawer";
import {
  CategoriesContainer,
  SearchContainer,
  Title,
} from "./ComponentsSearchPageStyles";
import { clearSearch } from "../../../reducers/componentSearch";
import { Category } from "../../../reducers/models/categories";
import { useRefreshSearch } from "../../../utils/hooks/partSearch";

export interface ComponentsSearchPageProps {
  categories: Category[];
}

export default function ComponentsSearchPage({
  categories,
}: ComponentsSearchPageProps) {
  const dispatch = useAppDispatch();
  useQuerySearch();
  const searchResponse = useAppSelector(
    (state) => state.componentSearch.searchResponse,
  );
  const loading = useAppSelector((state) => state.componentSearch.loading);
  const errored = useAppSelector((state) => state.componentSearch.errored);
  const [selectedPartId, setSelectedPartId] = useState<string | null>(null);
  const [isUpdated, setIsUpdated] = useState<boolean>(false);

  const refreshSearch = useRefreshSearch();

  const closeDrawer = () => {
    setSelectedPartId(null);
    if (isUpdated) {
      refreshSearch();
    }
    setIsUpdated(false);
  };
  useEffect(() => {
    setSelectedPartId(null);
  }, [searchResponse, setSelectedPartId]);

  useEffect(() => {
    return () => {
      dispatch(clearSearch());
    };
  }, [dispatch]);

  return (
    <>
      {searchResponse === null && !loading && !errored ? (
        <CategoriesContainer>
          <Title>Explore Parts</Title>
          <Categories
            categories={categories}
            description={
              "Browse the parts & components available to you when creating your bill of materials. " +
              "After uploading your board you can select these components for assembly."
            }
          />
        </CategoriesContainer>
      ) : (
        <SearchContainer>
          <Search
            categories={categories}
            setSelectedPartId={setSelectedPartId}
          />
          <PartDrawer
            partId={selectedPartId}
            setIsUpdated={setIsUpdated}
            onClose={closeDrawer}
          />
        </SearchContainer>
      )}
    </>
  );
}
